module.exports = __webpack_public_path__ + "static/media/ACRE.1e7e2073.png";